import MenuItem from '@ahamove/web-components/lib/MenuItem';
import type { SelectChangeEvent } from '@ahamove/web-components/lib/Select';
import Select from '@ahamove/web-components/lib/Select';
import Stack from '@ahamove/web-components/lib/Stack';
import Typography from '@ahamove/web-components/lib/Typography';
import Image from 'next/legacy/image';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { local } from '@/lib/storage';

const LanguageSwitch = () => {
  const router = useRouter();
  const { t } = useTranslation(['common']);
  const handleLanguageChange = (event: SelectChangeEvent) => {
    const locale = event.target.value;
    local.setItem('locale', JSON.stringify(locale));
    router.push(router.asPath, undefined, { locale });
  };

  return (
    <Select
      size="small"
      labelId="language-switch"
      value={router.locale}
      onChange={handleLanguageChange}
    >
      <MenuItem value="en">
        <Stack direction="row" spacing={1}>
          <div className="relative h-6 w-6">
            <Image src="/static/icons/England.svg" alt="" layout="fill" />
          </div>
          <Typography>{t('common:i18n.english')}</Typography>
        </Stack>
      </MenuItem>
      <MenuItem value="vi">
        <Stack direction="row" spacing={1}>
          <div className="relative h-6 w-6">
            <Image src="/static/icons/Vietnam.svg" alt="" layout="fill" />
          </div>
          <Typography>{t('common:i18n.vietnamese')}</Typography>
        </Stack>
      </MenuItem>
    </Select>
  );
};

export default LanguageSwitch;
